import React from 'react';
import { TableItemActionsNew, Icons, CommonTooltip } from 'components';
import { numberWithCommas } from 'utility/util';
const columns = (navigate, onOpenRequesyFinancialDg) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'نام زنجیره تامین',
    field: 'name', //multiConfirmationSrv?.id
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => row?.name || '-',
  },
  {
    title: 'نام مشتری کانونی',
    field: 'seller-name', //multiConfirmationSrv?.id
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => row?.['seller-name'] || '-',
  },

  {
    title: 'سقف اعتبار',
    field: 'credit-limit', //multiConfirmationSrv?.id
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) =>
      row?.status == 'CONFIRMED' ? (
        <>{numberWithCommas(row?.['credit-limit'])}</>
      ) : (
        <CommonTooltip
          placement="top"
          title="مبلغ اعتبار قابل تخصیص به هر خریدار، پس از ثبت درخواست و اعتبارسنجی توسط شعبه مشخص خواهد شد."
        >
          <span className={classes.infoIcon}>
            <Icons icon='Info' color='#667585' hover='#667585' size='20' />
          </span>
        </CommonTooltip>
      ),
  },
  {
    title: 'نحوه بازپرداخت',
    field: 'repayment-type', //multiConfirmationSrv?.id
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => row?.['repayment-type'] || '-',
  },

  {
    title: 'وثیقه مورد نیاز',
    field: 'collaterals', //multiConfirmationSrv?.id
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => row?.['collaterals'] || '-',
  },

  {
    title: 'وضعیت درخواست اعتبار',
    field: 'status', //multiConfirmationSrv?.id
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => statusLoan[row?.status] || '-',
  },

  {
    title: 'عملیات',
    field: '',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (row) => (
      <TableItemActionsNew
        iconButton
        startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
        title=""
        otherMenus={[
          {
            title: 'ثبت درخواست اعتبار',
            isShow: true,
            onClick: () => { onOpenRequesyFinancialDg(row) },
            disabled: checkActiveOrDeactiveButton(row),
          },
          {
            title: 'جزئیات قرارداد',
            isShow: true,
            onClick: () => {
              navigate(`/InvoiceFinancing/Invoices/${row?.['loan-id']}`, {
                state: row,
              })
            },
            disabled: row?.status != 'CONFIRMED',
          },
        ]}
      />
    ),
  },
];

const statusLoan = {
  PENDING: 'در انتظار ثبت درخواست',
  PENDING_TO_CONFIRM: 'در انتظار تایید بانک',
  CONFIRMED: 'تایید شده',
  REJECTED: 'رد شده',
};
/**
 * اگر وضعیت قرارداد فعال است و وضعیت درخواست در انتظار تایید باشد اکمه اکتیو و در غیر اینصورت غیرفعال است
 */
const checkActiveOrDeactiveButton = (row) => {
  if (row?.status == 'PENDING' || row?.status == 'REJECTED') {
    return false;
  } else {
    return true;
  }
};
const generateData = (rows, query) => {
  return rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
};

export { columns, generateData };
